import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  MenuItem,
  withStyles,
  Grid,
  Select,
  DialogActions,
  Dialog,
  Button,
  // TextField,
  DialogContent,
  DialogTitle,
  Paper,
  // Chip
} from '@material-ui/core';
import './styles/dialog.css';
import { withTranslation } from 'react-i18next';
import { notification } from 'antd';
import Swal from 'sweetalert2';
import FormInputLabel from '../FormInputLabelView';
class Movement extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.props.state;
  }

  onMoveChange = (value) => {
    this.setState({
      ...this.state,
      movement: { ...this.state.movement, id: value },
    });
  };

  handleMove = async () => {
    if (this.state.movement.id !== 0) {
      try {
        let { props, t, dataBed } = this.props;
        // const bed = props.data;
        const bed = props.data ? props.data : dataBed;
        const { user } = this.props.dashboard.toJS();
        let subgroup = user.find((val) => val.id === this.state.movement.id);
        if (bed.patient.devices.length > 0) {
          let allowMoving = false;
          const serials = bed.patient.devices.map((device) => device.serial);
          const devices = await this.props.device.findBySerials(serials);
          if (devices && devices.length > 0) {
            const found = devices.filter((dev) => {
              if (dev.subgroupPermission) {
                const permisstion = JSON.parse(dev.subgroupPermission);
                return permisstion.includes(subgroup.subGroupId);
              }
              return false;
            });

            allowMoving = found.length === devices.length;
          }

          if (allowMoving) {
            await this.props.dashboard.discharge(bed, false);
            await this.props.dashboard.patientAdmit(bed, this.state.movement.id, 'move');
            this.setState({
              ...this.state,
              movement: { ...this.state.movement, id: 0 },
            });
          } else {
            Swal.fire({
              html: `<h4>${t('unable_to_move_patient')}<h4>${t('please_unassigned_device')}`,
              type: 'warning',
            });
          }
        } else {
          await this.props.dashboard.discharge(bed, false);
          await this.props.dashboard.patientAdmit(bed, this.state.movement.id, 'move');
          this.setState({
            ...this.state,
            movement: { ...this.state.movement, id: 0 },
          });
        }
      } catch (err) {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
      this.props.handleClose();
    } else {
      alert('Please select room');
    }
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      movement: { ...this.state.movement, id: 0 },
    });
    this.props.handleClose();
  };

  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  render() {
    let { props, state, t, patientData } = this.props;
    const patient = props.data ? props.data.patient : patientData;
    const { user } = this.props.dashboard.toJS();
    let result = user.filter((bed) => !bed.patient);
    result = result.sort((a, b) => {
      let nameA = a.roomName + '/' + a.name;
      let nameB = b.roomName + '/' + b.name;
      nameA = nameA.toUpperCase();
      nameB = nameB.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

    const fullname = this.getFullname(localStorage.getItem('i18nextLng'), patient);
    return (
      <Dialog
        open={state.dialogMovement.open}
        onClose={this.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          {/* <Chip 
            color="primary" 
            label={(props.data.roomName && props.data.name ) ? `${props.data.roomName}/${props.data.name}` : props.data.roomName || props.data.name}
            className={classes.chip} 
          /> */}
          <Grid container style={{ position: 'relative' }}>
            <div>
              {t('assign_device_to')} <span className='headerMain'>{fullname}</span>
            </div>
            <div className='closeIcon' onClick={this.handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} sm={1}>
              <FormInputLabel label={t('move_to_bed')} />
            </Grid>
            <Grid item xs={12} sm={11}>
              <Paper className={`${props.classes.root} selectInput`}>
                <Select
                  value={this.state.movement.id || 0}
                  onChange={(e) => {
                    this.onMoveChange(e.target.value);
                  }}
                  fullwidth='true'
                  inputProps={{
                    name: 'move-to-bed',
                    id: 'move-to-bed',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_bed')}
                  </MenuItem>
                  {(result || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {val.roomName && val.name ? `${val.roomName}/${val.name}` : val.roomName || val.name}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              {/* <FormControl
                component="fieldset"
                className={props.classes.formControl}
                style={{ width: '100%' }}
              >
                <InputLabel htmlFor="move-to-bed">{t('move_to_bed')}</InputLabel>
                <Paper className={`${props.classes.root} selectInput`}>
                  <Select
                    value={this.state.movement.id || 0}
                    onChange={e => {
                      this.onMoveChange(e.target.value);
                    }}
                    fullwidth="true"
                    inputProps={{
                      name: 'move-to-bed',
                      id: 'move-to-bed',
                    }}
                  >
                    <MenuItem fullwidth="true" key={0} value={0}>
                      {t('please_select_bed')}
                    </MenuItem>
                    {(result || []).map(val => (
                      <MenuItem fullwidth="true" key={val.id} value={val.id}>
                        {val.roomName && val.name ? `${val.roomName}/${val.name}` : val.roomName || val.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </FormControl> */}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={this.handleClose} color="default">
            {t('cancel')}
          </Button>
          <Button onClick={this.handleMove} color="primary">
            {t('move')}
          </Button> */}
          <Grid
            container
            item
            style={{
              margin: '10px 28px',
              justifyContent: 'right',
            }}
          >
            <Button
              onClick={this.handleMove}
              color='primary'
              id='save'
              variant='contained'
              style={{
                width: 100,
              }}
            >
              {t('move')}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  chip: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#fff',
    marginLeft: '5px',
  },
});

export const page = inject('dashboard', 'device')(observer(Movement));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
